/**
 *
 * Button.js
 *
 * A common button
 * if you pass it a prop "to" it'll render a Link element
 * if you pass it a prop "href" it'll render a link tag
 * otherwise it'll render a button with an onclick
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Isvg from 'react-inlinesvg';

class Button extends React.Component {
    render() {
        const { children, to, href, className, icon, download, onClick } = this.props;
        let cn = 'btn';
        let elIcon = '';

        if (className) {
            cn += ` ${className}`;
        }

        if (icon) {
            switch (icon) {
                case 'back':
                    elIcon = <Isvg src="/svg/arrow-left-mobile.svg" className="icon-back" />;
                    cn += ' is-icon';
                    break;
            }
        }

        const params = {
            className: cn,
        };

        if (onClick) {
            params.onClick = onClick;
        }

        let btn = (
            <button {...params}>
                {elIcon}
                {this.props.children}
            </button>
        );

        if (to) {
            btn = (
                <Link to={to} {...params}>
                    {elIcon}
                    {this.props.children}
                </Link>
            );
        } else if (href) {
            if (download) {
                params.download = true;
            }
            btn = (
                <a href={href} {...params}>
                    {elIcon}
                    {this.props.children}
                </a>
            );
        }

        return btn;
    }
}

Button.propTypes = {
    children: PropTypes.node.isRequired,
    to: PropTypes.string,
    href: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string,
    icon: PropTypes.string,
    download: PropTypes.bool,
};

export default Button;
